import{useRef as r}from"react";var n=1;function t(t){var c=r(null);return null===c.current&&(c.current="".concat(t,"-").concat(n++)),c.current}export{t as useId};
//# sourceMappingURL=use-id.js.map
